import { defineContent, type DefinedContent } from '@post-office/define-content';

export const registeredContent: DefinedContent<{
	default: ['header', 'cta'];
	createSpace: ['header', 'cta'];
	createPage: ['header', 'cta'];
	createWhiteboard: ['header', 'cta'];
}> = defineContent({
	// `default` is required by the content contract. This placement selects copy at runtime by
	// next-best-action type, so `default` mirrors the primary create-space copy as a fallback.
	default: {
		header: {
			id: 'post-office.confluence-side-nav.next-best-action.craete-space-header',
			defaultMessage: "Centralize your team's projects, and docs.",
			description: 'Header text for confluence side nav next best action banner',
			role: 'title',
		},
		cta: {
			id: 'post-office.confluence-side-nav.next-best-action.create-space-cta-message',
			defaultMessage: 'Create space',
			description: 'Call to action text for confluence side nav next best action banner',
			role: 'description',
		},
	},
	createSpace: {
		header: {
			id: 'post-office.confluence-side-nav.next-best-action.craete-space-header',
			defaultMessage: "Centralize your team's projects, and docs.",
			description: 'Header text for confluence side nav next best action banner',
			role: 'title',
		},
		cta: {
			id: 'post-office.confluence-side-nav.next-best-action.create-space-cta-message',
			defaultMessage: 'Create space',
			description: 'Call to action text for confluence side nav next best action banner',
			role: 'description',
		},
	},
	createPage: {
		header: {
			id: 'post-office.confluence-side-nav.next-best-action.create-page-header',
			defaultMessage: 'Plan projects, take notes, and track tasks.',
			description: 'Header text for confluence side nav next best action banner',
			role: 'title',
		},
		cta: {
			id: 'post-office.confluence-side-nav.next-best-action.create-page-cta-message',
			defaultMessage: 'Create page',
			description: 'Call to action text for confluence side nav next best action banner',
			role: 'description',
		},
	},
	createWhiteboard: {
		header: {
			id: 'post-office.confluence-side-nav.next-best-action.create-whiteboard-header',
			defaultMessage: 'Dream up new ideas, and visualize your work.',
			description: 'Header text for confluence side nav next best action banner',
			role: 'title',
		},
		cta: {
			id: 'post-office.confluence-side-nav.next-best-action.create-whiteboard-cta-message',
			defaultMessage: 'Create whiteboard',
			description: 'Call to action text for confluence side nav next best action banner',
			role: 'description',
		},
	},
});
